<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 class="serviceTestTitle">Insurance Verication Test</h1>
                        <div class="mt10 fs14 lh25">Testing Questions to better understand where your knowledge lies with Insurance Verification.
                        </div>
                        <p class="required" style="margin: 10px 0">* Required</p>
                    </div>

                    <el-form :model="form" :inline="false" :rules="rules" ref="form">
                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub0!=0" :src="wrong"></el-image>
                                1) Teeth Numbers #1-16 are a part of what arch? *<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub0">
                                <el-radio-group ref="sub0" v-model="form.sub0" :disabled="isAdmin">
                                    <el-radio :label="0">Maxillary Arch</el-radio>
                                    <el-image v-if="isAdmin&&form.sub0!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Mandibular Arch</el-radio><br>
                                    <el-radio :label="2">Buccal Arch</el-radio><br>
                                    <el-radio :label="3">Lingual Arch</el-radio><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub1!=0" :src="wrong"></el-image>
                                2) Does the Primary Dentition consist of numbers or letters?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub1">
                                <el-radio-group ref="sub1" v-model="form.sub1" :disabled="isAdmin">
                                    <el-radio :label="0">Letters</el-radio>
                                    <el-image v-if="isAdmin&&form.sub1!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Numbers</el-radio><br>
                                    <el-radio :label="2">Both Letters & Numbers</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub2!=1" :src="wrong"></el-image>
                                3) The annual Maximum is the Total Amount that a plan will pay for Dental Coverage in a Calendar Year.<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub2">
                                <el-radio-group ref="sub2" style="width: 100%" v-model="form.sub2" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub2!=1" class="rightPic" :src="right"></el-image><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub3!=4" :src="wrong"></el-image>
                                4) Insurance Policies can have what types of benefit timeframes?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub3" class="mt20">
                                <el-radio-group ref="sub3" style="width: 100%" v-model="form.sub3" :disabled="isAdmin">
                                    <el-radio :label="0">Calendar Year</el-radio><br>
                                    <el-radio :label="1">Fiscal Year</el-radio><br>
                                    <el-radio :label="2">Benefit Year</el-radio><br>
                                    <el-radio :label="3">Month to Month</el-radio><br>
                                    <el-radio :label="4">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub3!=4" class="rightPic" :src="right"></el-image><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&(!form.sub4.a||form.sub4.b||form.sub4.c||form.sub4.d||form.sub4.e)" :src="wrong"></el-image>
                                5) What does frequency/limitations mean for a dental insurance plan? <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub4" ref="sub4">
                                <el-checkbox v-model="form.sub4.a" :disabled="isAdmin">It limits the number of times a service can be performed in a given time period</el-checkbox>
                                <el-image v-if="isAdmin&&(!form.sub4.a||form.sub4.b||form.sub4.c||form.sub4.d||form.sub4.e)" class="rightPic" :src="right"></el-image><br>
                                <el-checkbox v-model="form.sub4.b" :disabled="isAdmin">It is the time frame that a patient must wait before they can have a procedure completed</el-checkbox><br>
                                <el-checkbox v-model="form.sub4.c" :disabled="isAdmin">It is a procedure that is considered a non-covered benefit for the policy</el-checkbox><br>
                                <el-checkbox v-model="form.sub4.d" :disabled="isAdmin">It is considered an ineligible procedure and the patient has to pay out-of-pocket</el-checkbox><br>
                                <el-checkbox v-model="form.sub4.e" :disabled="isAdmin">It is considered an ineligible procedure and the office has to adjust fee</el-checkbox>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub5!=3" :src="wrong"></el-image>
                                6) Why are intermediate (temp) restorations used in dentistry?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub5">
                                <el-radio-group ref="sub5" v-model="form.sub5" :disabled="isAdmin">
                                    <el-radio :label="0">Financial Reasons</el-radio><br>
                                    <el-radio :label="1">To determine the health of the tooth</el-radio><br>
                                    <el-radio :label="2">Waiting for Permanent Restoration</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub5!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub6!=5" :src="wrong"></el-image>
                                7) Which of the following codes typically share a frequency?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub6">
                                <el-radio-group ref="sub6" v-model="form.sub6" :disabled="isAdmin">
                                    <el-radio :label="0">D4910</el-radio><br>
                                    <el-radio :label="1">D1110</el-radio><br>
                                    <el-radio :label="2">D1206</el-radio><br>
                                    <el-radio :label="3">D1208</el-radio><br>
                                    <el-radio :label="4">D1203</el-radio><br>
                                    <el-radio :label="5">D4910 & D1110</el-radio>
                                    <el-image v-if="isAdmin&&form.sub6!=5" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="6">D1206 & D1203</el-radio><br>
                                    <el-radio :label="7">D1110 & D1206</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub7!=2" :src="wrong"></el-image>
                                8) What type of film allows the entire dentition to be viewed on a single film?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub7">
                                <el-radio-group ref="sub7" v-model="form.sub7" :disabled="isAdmin">
                                    <el-radio :label="0">Occlusal</el-radio><br>
                                    <el-radio :label="1">Cephalometric</el-radio><br>
                                    <el-radio :label="2">Panorex</el-radio><el-image v-if="isAdmin&&form.sub7!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub8!=4" :src="wrong"></el-image>
                                9) Which of the following x-rays typically share the frequency limitation?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub8">
                                <el-radio-group ref="sub8" v-model="form.sub8" :disabled="isAdmin">
                                    <el-radio :label="0">FMX</el-radio><br>
                                    <el-radio :label="1">Pano</el-radio><br>
                                    <el-radio :label="2">PA</el-radio><br>
                                    <el-radio :label="3">BWX</el-radio><br>
                                    <el-radio :label="4">FMX & Pano</el-radio>
                                    <el-image v-if="isAdmin&&form.sub8!=4" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="5">FMX & BWX</el-radio><br>
                                    <el-radio :label="6">Pano & PA</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub9!=2" :src="wrong"></el-image>
                                10) The following image is considered which type of x-ray<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="xRay1"></el-image>
                            <el-form-item prop="sub9" ref="sub9">
                                <el-radio-group ref="sub9" v-model="form.sub9" :disabled="isAdmin">
                                    <el-radio :label="0">Cephalometric</el-radio><br>
                                    <el-radio :label="1">BWX</el-radio><br>
                                    <el-radio :label="2">Panorex</el-radio>
                                    <el-image v-if="isAdmin&&form.sub9!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">CT Scan</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub10!=2" :src="wrong"></el-image>
                                11) What is on the lower anterior teeth?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="xRay1"></el-image>
                            <el-form-item prop="sub10">
                                <el-radio-group ref="sub10" v-model="form.sub10" :disabled="isAdmin">
                                    <el-radio :label="0">Bi-lateral Lower Spacer</el-radio><br>
                                    <el-radio :label="1">Perio Splinting Bar</el-radio><br>
                                    <el-radio :label="2">Lower Fixed Retainer</el-radio>
                                    <el-image v-if="isAdmin&&form.sub10!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">Removable Retainer</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub11!=3" :src="wrong"></el-image>
                                12) The above film is best sent to the Insurance Company when trying to get "BLANK" paid.<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="xRay1"></el-image>
                            <el-form-item prop="sub11">
                                <el-radio-group ref="sub11" v-model="form.sub11" :disabled="isAdmin">
                                    <el-radio :label="0">Extractions</el-radio><br>
                                    <el-radio :label="1">Ortho</el-radio><br>
                                    <el-radio :label="2">Bridge</el-radio><br>
                                    <el-radio :label="3">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub11!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub12!=1" :src="wrong"></el-image>
                                13) How many wisdom teeth are visible in the xray below?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="xRay1"></el-image>
                            <el-form-item prop="sub12">
                                <el-radio-group ref="sub12" v-model="form.sub12" :disabled="isAdmin">
                                    <el-radio :label="0">2</el-radio><br>
                                    <el-radio :label="1">4</el-radio>
                                    <el-image v-if="isAdmin&&form.sub12!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">3</el-radio><br>
                                    <el-radio :label="3">0</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub13!=0" :src="wrong"></el-image>
                                14) Which type of dental radiograph shows 3D Images?<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub13">
                                <el-radio-group ref="sub13" v-model="form.sub13" :disabled="isAdmin">
                                    <el-radio :label="0">CBCT/CT Scan</el-radio>
                                    <el-image v-if="isAdmin&&form.sub13!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Panorex</el-radio><br>
                                    <el-radio :label="2">Occlusal</el-radio><br>
                                    <el-radio :label="3">BWX</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub14!=1" :src="wrong"></el-image>
                                15) Having Dual Insurance means the patient will not have an out-of-pocket expense.<span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub14">
                                <el-radio-group ref="sub14" v-model="form.sub14" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub14!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub15!=2" :src="wrong"></el-image>
                                16) If both parents hold dental insurance for the children, how do you know which insurance is Primary?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub15">
                                <el-radio-group ref="sub15" v-model="form.sub15" :disabled="isAdmin">
                                    <el-radio :label="0">The parent that is older</el-radio><br>
                                    <el-radio :label="1">The parent that had the insurance first</el-radio><br>
                                    <el-radio :label="2">The parent who's birthday month is first in the Calendar year</el-radio>
                                    <el-image v-if="isAdmin&&form.sub15!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">The parent that has the better plan</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub16!=0" :src="wrong"></el-image>
                                17) When an insurance states they have a Missing Tooth Clause (MTC), this means:
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub16">
                                <el-radio-group ref="sub16" v-model="form.sub16" :disabled="isAdmin">
                                    <el-radio :label="0">No coverage for any teeth extracted prior to the effective date</el-radio>
                                    <el-image v-if="isAdmin&&form.sub16!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No coverage for the retainers</el-radio><br>
                                    <el-radio :label="2">No coverage for the bridges</el-radio><br>
                                    <el-radio :label="3">The patient has to wait 6 months before they will cover</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub17!=5" :src="wrong"></el-image>
                                18) What is considered required information for an insurance benefit breakdown?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub17">
                                <el-radio-group ref="sub17" v-model="form.sub17" :disabled="isAdmin">
                                    <el-radio :label="0">Group Number</el-radio><br>
                                    <el-radio :label="1">Effective Date</el-radio><br>
                                    <el-radio :label="2">Benefit Maximum</el-radio><br>
                                    <el-radio :label="3">Payor ID</el-radio><br>
                                    <el-radio :label="4">Frequency & Limitations</el-radio><br>
                                    <el-radio :label="5">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub17!=5" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub18!=1" :src="wrong"></el-image>
                                19) In order to obtain the full insurance breakdown for a patient, you must have their SSN.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub18">
                                <el-radio-group ref="sub18" v-model="form.sub18" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub18!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub19!=3" :src="wrong"></el-image>
                                20) Which statement below best describes "the waiting period" with an insurance plan?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub19">
                                <el-radio-group ref="sub19" v-model="form.sub19" :disabled="isAdmin">
                                    <el-radio :label="0">The Insurance will not pay benefits until the patient has paid their Premium</el-radio><br>
                                    <el-radio :label="1">The Office must wait 30 days before starting treatment</el-radio><br>
                                    <el-radio :label="2">The patient can choose to wait XXX days to get the treatment</el-radio><br>
                                    <el-radio :label="3">The office must wait XXX days until the Insurance will cover a procedure</el-radio>
                                    <el-image v-if="isAdmin&&form.sub19!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub20!=1" :src="wrong"></el-image>
                                21) Primary and Secondary insurance are typically billed at the same time.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub20">
                                <el-radio-group ref="sub20" v-model="form.sub20" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub20!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub21!=1" :src="wrong"></el-image>
                                22) When verifying insurance, what do frequencies typically mean?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub21">
                                <el-radio-group ref="sub21" v-model="form.sub21" :disabled="isAdmin">
                                    <el-radio :label="0">How often the patient should have the procedure done</el-radio><br>
                                    <el-radio :label="1">How often the Insurance will pay for the procedure</el-radio>
                                    <el-image v-if="isAdmin&&form.sub21!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">The office cannot charge the patient if over the frequency</el-radio><br>
                                    <el-radio :label="3">How often you may inquire on a patients benefits</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub22!=1" :src="wrong"></el-image>
                                23) Alternate (downgrade) benefit information is not necessary to gather when verifying insurance.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub22">
                                <el-radio-group ref="sub22" v-model="form.sub22" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub22!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub23!=0" :src="wrong"></el-image>
                                24) It is important to verify whether the provider is in-network or out-of-network when verifying insurance plans for offices.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub23">
                                <el-radio-group ref="sub23" v-model="form.sub23" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio>
                                    <el-image v-if="isAdmin&&form.sub23!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">False</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub24!=0" :src="wrong"></el-image>
                                25) The Subscriber of the Insurance can be different than the patient.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub24">
                                <el-radio-group ref="sub24" v-model="form.sub24" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio>
                                    <el-image v-if="isAdmin&&form.sub24!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">False</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub25!=1" :src="wrong"></el-image>
                                26) If the patient has a Deductible, this applies to all procedures.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub25">
                                <el-radio-group ref="sub25" v-model="form.sub25" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub25!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub26!=1" :src="wrong"></el-image>
                                27) All insurances pay a percentage of what the office has billed for the procedures.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub26">
                                <el-radio-group ref="sub26" v-model="form.sub26" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub26!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub27!=1" :src="wrong"></el-image>
                                28) The Group Name is ALWAYS the patient's Employer.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub27">
                                <el-radio-group ref="sub27" v-model="form.sub27" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub27!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub28!=2" :src="wrong"></el-image>
                                29) Which is the least efficient way of verifying a patient's Insurance
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub28">
                                <el-radio-group ref="sub28" v-model="form.sub28" :disabled="isAdmin">
                                    <el-radio :label="0">Call the Insurance Company</el-radio><br>
                                    <el-radio :label="1">Request a Fax back</el-radio><br>
                                    <el-radio :label="2">Request a copy of the patients benefit booklet</el-radio>
                                    <el-image v-if="isAdmin&&form.sub28!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">Use the Insurance Portal</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub29!=3" :src="wrong"></el-image>
                                30) What is an Insurance Portal?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub29">
                                <el-radio-group ref="sub29" v-model="form.sub29" :disabled="isAdmin">
                                    <el-radio :label="0">A detailed booklet the insurance gives to the patient</el-radio><br>
                                    <el-radio :label="1">A site the Insurance sets up for the patient to send their monthly premium</el-radio><br>
                                    <el-radio :label="2">A site the Insurance sets up to research practice information</el-radio><br>
                                    <el-radio :label="3">A site the Insurance sets up to research patient Insurance information and submit claims</el-radio>
                                    <el-image v-if="isAdmin&&form.sub29!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub30!=3" :src="wrong"></el-image>
                                31) Why is it important to verify a patient's Dental Insurance?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub30">
                                <el-radio-group ref="sub30" v-model="form.sub30" :disabled="isAdmin">
                                    <el-radio :label="0">Federal and State require this of all offices who participate with Dental Plans</el-radio><br>
                                    <el-radio :label="1">Insurance companies require this</el-radio><br>
                                    <el-radio :label="2">The office will be fined if they do not follow this policy</el-radio><br>
                                    <el-radio :label="3">It helps estimate the patients co-payments and co-insurance for the appointments</el-radio>
                                    <el-image v-if="isAdmin&&form.sub30!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub31!=0" :src="wrong"></el-image>
                                32) Most insurances have an Individual Deductible and a Family Deductible.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub31">
                                <el-radio-group ref="sub31" v-model="form.sub31" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio>
                                    <el-image v-if="isAdmin&&form.sub31!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">False</el-radio>

                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub32!=1" :src="wrong"></el-image>
                                33) If the Insurance portal does not have all of the information needed for the breakdown, what would your next step be?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub32">
                                <el-radio-group ref="sub32" v-model="form.sub32" :disabled="isAdmin">
                                    <el-radio :label="0">Call the office</el-radio><br>
                                    <el-radio :label="1">Call the Insurance</el-radio>
                                    <el-image v-if="isAdmin&&form.sub32!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Request a Fax</el-radio><br>
                                    <el-radio :label="3">If the Portal does not have the information, it is not available.</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub33!=1" :src="wrong"></el-image>
                                34) Most Dental Insurances cover both intermediate and permanent dentures.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub33">
                                <el-radio-group ref="sub33" v-model="form.sub33" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub33!=1" class="rightPic" :src="right"></el-image><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub34!=2" :src="wrong"></el-image>
                                35) Which one of the following is not typically considered a “Dental Category”?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub34">
                                <el-radio-group ref="sub34" v-model="form.sub34" :disabled="isAdmin">
                                    <el-radio :label="0">Preventative</el-radio><br>
                                    <el-radio :label="1">Major</el-radio><br>
                                    <el-radio :label="2">Medical</el-radio>
                                    <el-image v-if="isAdmin&&form.sub34!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">Basic</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&(!form.sub35.d||form.sub35.a||form.sub35.b||form.sub35.c)" :src="wrong"></el-image>
                                36) When verifying Insurance, it is important to gather ___________ from the Insurance
                                for future reference? (Select all that apply)
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub35" ref="sub35">
                                <el-checkbox v-model="form.sub35.a" :disabled="isAdmin">The representative’s name</el-checkbox><br>
                                <el-checkbox v-model="form.sub35.b" :disabled="isAdmin">The Date of the Call</el-checkbox><br>
                                <el-checkbox v-model="form.sub35.c" :disabled="isAdmin">A reference number</el-checkbox><br>
                                <el-checkbox v-model="form.sub35.d" :disabled="isAdmin">All of the above</el-checkbox>
                                <el-image v-if="isAdmin&&(!form.sub35.d||form.sub35.a||form.sub35.b||form.sub35.c)" class="rightPic" :src="right"></el-image>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&(form.sub36.a||!form.sub36.b||form.sub36.c||form.sub36.d||!form.sub36.e||!form.sub36.f||form.sub36.g)" :src="wrong"></el-image>
                                37) When verifying Insurance, which information is NOT necessary to retrieve the data you are requesting? (Select all that apply)
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub36" ref="sub36">
                                <el-checkbox v-model="form.sub36.a" :disabled="isAdmin">The Patient's name and DOB</el-checkbox><br>
                                <el-checkbox v-model="form.sub36.b" :disabled="isAdmin">The patient's sex</el-checkbox>
                                <el-image v-if="isAdmin&&(form.sub36.a||!form.sub36.b||form.sub36.c||form.sub36.d||!form.sub36.e||!form.sub36.f||form.sub36.g)" class="rightPic" :src="right"></el-image><br>
                                <el-checkbox v-model="form.sub36.c" :disabled="isAdmin">The Office information</el-checkbox><br>
                                <el-checkbox v-model="form.sub36.d" :disabled="isAdmin">The Subscriber name, ID number and DOB</el-checkbox><br>
                                <el-checkbox v-model="form.sub36.e" :disabled="isAdmin">The patient's employer</el-checkbox>
                                <el-image v-if="isAdmin&&(form.sub36.a||!form.sub36.b||form.sub36.c||form.sub36.d||!form.sub36.e||!form.sub36.f||form.sub36.g)" class="rightPic" :src="right"></el-image><br>
                                <el-checkbox v-model="form.sub36.f" :disabled="isAdmin">The home address for the patient</el-checkbox>
                                <el-image v-if="isAdmin&&(form.sub36.a||!form.sub36.b||form.sub36.c||form.sub36.d||!form.sub36.e||!form.sub36.f||form.sub36.g)" class="rightPic" :src="right"></el-image><br>
                                <el-checkbox v-model="form.sub36.g" :disabled="isAdmin">All of the above</el-checkbox>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub37!=1" :src="wrong"></el-image>
                                38) If an insurance plan is already entered into the Practice Software, it is NOT necessary to verify the patient's coverage.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub37">
                                <el-radio-group ref="sub37" v-model="form.sub37" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub37!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub38!=1" :src="wrong"></el-image>
                                39) The reason we verify a patient's dental insurance is so we can guarantee payment from the insurance company.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub38">
                                <el-radio-group ref="sub38" v-model="form.sub38" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub38!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub39!=0" :src="wrong"></el-image>
                                40) Verifying specific codes is sometimes necessary to determine coverage as there are
                                many non-covered procedures within the specific categories of coverage.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub39">
                                <el-radio-group ref="sub39" v-model="form.sub39" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio>
                                    <el-image v-if="isAdmin&&form.sub39!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">False</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub40!=1" :src="wrong"></el-image>
                                41) Delta Dental has one Corporate Office and one phone number that accepts all calls
                                for any Delta plan, regardless of the State.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub40">
                                <el-radio-group ref="sub40" v-model="form.sub40" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub40!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub41!=2" :src="wrong"></el-image>
                                42) HIPAA stands for:
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub41">
                                <el-radio-group ref="sub41" v-model="form.sub41" :disabled="isAdmin">
                                    <el-radio :label="0">Health Insurance Profitability and Accountability</el-radio><br>
                                    <el-radio :label="1">Home Individual Profits and Ascension</el-radio><br>
                                    <el-radio :label="2">Health Insurance Portability and Accountability Act</el-radio>
                                    <el-image v-if="isAdmin&&form.sub41!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">Health Individual Profits and Accounts</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub42!=1" :src="wrong"></el-image>
                                43) It is NOT necessary to verify Orthodontic Benefits if you are calling for a General Dental Office.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-form-item prop="sub42">
                                <el-radio-group ref="sub42" v-model="form.sub42" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub42!=1" class="rightPic" :src="right"></el-image><br>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&(!form.sub43.c||form.sub43.a||form.sub43.b||form.sub43.d)" :src="wrong"></el-image>
                                44) What is the Payor ID for this Carrier?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt20" :src="sub46"></el-image>
                            <el-form-item prop="sub43" ref="sub43">
                                <el-checkbox v-model="form.sub43.a" :disabled="isAdmin">0302280</el-checkbox><br>
                                <el-checkbox v-model="form.sub43.b" :disabled="isAdmin">0019</el-checkbox><br>
                                <el-checkbox v-model="form.sub43.c" :disabled="isAdmin">65978</el-checkbox>
                                <el-image v-if="isAdmin&&(!form.sub43.c||form.sub43.a||form.sub43.b||form.sub43.d)" class="rightPic" :src="right"></el-image><br>
                                <el-checkbox v-model="form.sub43.d" :disabled="isAdmin">6383379</el-checkbox><br>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub44!=1" :src="wrong"></el-image>
                                45) Does this plan have a MTC (Missing Tooth Clause)?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub47"></el-image>
                            <el-form-item prop="sub44">
                                <el-radio-group ref="sub44" v-model="form.sub44" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio><br>
                                    <el-radio :label="1">No</el-radio>
                                    <el-image v-if="isAdmin&&form.sub44!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub45!=0" :src="wrong"></el-image>
                                46) Based on this image, if the patient's appointment is 03/17/2019, is the patient eligible
                                for an FMX?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub48"></el-image>
                            <el-form-item prop="sub45">
                                <el-radio-group ref="sub45" v-model="form.sub45" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub45!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No</el-radio><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub46!=1" :src="wrong"></el-image>
                                47) Based on the image above, what statement is true.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub49"></el-image>
                            <el-form-item prop="sub46">
                                <el-radio-group ref="sub46" v-model="form.sub46" :disabled="isAdmin">
                                    <el-radio :label="0">The patient can have an Exam done 1 time in 6 months</el-radio><br>
                                    <el-radio :label="1">The patient can have an Exam done 2 times, anytime during the Calendar Year</el-radio>
                                    <el-image v-if="isAdmin&&form.sub46!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">The patient can have an Exam done 1 time + 1 day in 6 months</el-radio><br>
                                    <el-radio :label="3">The patient does not have a frequency for the Limited Exams</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub47!=0" :src="wrong"></el-image>
                                48) Looking at this image, what type of insurance plan does this patient have?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub50"></el-image>
                            <el-form-item prop="sub47">
                                <el-radio-group ref="sub47" v-model="form.sub47" :disabled="isAdmin">
                                    <el-radio :label="0">DMO</el-radio>
                                    <el-image v-if="isAdmin&&form.sub47!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">PPO</el-radio><br>
                                    <el-radio :label="2">Medical</el-radio><br>
                                    <el-radio :label="3">Indemnity</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub48!=1" :src="wrong"></el-image>
                                49) Based on this image, is the patient eligible for a PANOREX for DOS: 1/20/2020?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub51"></el-image>
                            <el-form-item prop="sub48">
                                <el-radio-group ref="sub48" v-model="form.sub48" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio><br>
                                    <el-radio :label="1">No</el-radio>
                                    <el-image v-if="isAdmin&&form.sub48!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub49!=0" :src="wrong"></el-image>
                                50) Using the image below, Are the Preventive Services subject to just the deductible,
                                just the maximum or both the deductible and the maximum?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub52"></el-image>
                            <el-form-item prop="sub49">
                                <el-radio-group ref="sub49" v-model="form.sub49" :disabled="isAdmin">
                                    <el-radio :label="0">Neither Deductible or Maximum</el-radio>
                                    <el-image v-if="isAdmin&&form.sub49!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Just the Deductible</el-radio><br>
                                    <el-radio :label="2">Just the Maximum</el-radio><br>
                                    <el-radio :label="3">Both the Deductible & the Maximum</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub50!=1" :src="wrong"></el-image>
                                51) Based on the image below, do all exams share the frequency?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub53"></el-image>
                            <el-form-item prop="sub50">
                                <el-radio-group ref="sub50" v-model="form.sub50" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio><br>
                                    <el-radio :label="1">No</el-radio>
                                    <el-image v-if="isAdmin&&form.sub50!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub51!=0" :src="wrong"></el-image>
                                52) Based on the image below, does this plan have a missing tooth clause (MTC)?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub54"></el-image>
                            <el-form-item prop="sub51">
                                <el-radio-group ref="sub51" v-model="form.sub51" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub51!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No</el-radio><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub52!=1" :src="wrong"></el-image>
                                53) Based on the image below, when is the patient eligible for Fluoride?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub55"></el-image>
                            <el-form-item prop="sub52">
                                <el-radio-group ref="sub52" v-model="form.sub52" :disabled="isAdmin">
                                    <el-radio :label="0">09/12/2019</el-radio><br>
                                    <el-radio :label="1">09/13/2019</el-radio>
                                    <el-image v-if="isAdmin&&form.sub52!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">09/01/2019</el-radio><br>
                                    <el-radio :label="3">09/06/2019</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub53!=1" :src="wrong"></el-image>
                                54) Based on the image below, what is the individual Yearly Maximum?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub56"></el-image>
                            <el-form-item prop="sub53">
                                <el-radio-group ref="sub53" v-model="form.sub53" :disabled="isAdmin">
                                    <el-radio :label="0">$1000</el-radio><br>
                                    <el-radio :label="1">$1500</el-radio>
                                    <el-image v-if="isAdmin&&form.sub53!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">$150</el-radio><br>
                                    <el-radio :label="3">$50</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub54!=0" :src="wrong"></el-image>
                                55) Based on the image below, the patient has used how much of their maximum?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub57"></el-image>
                            <el-form-item prop="sub54">
                                <el-radio-group ref="sub54" v-model="form.sub54" :disabled="isAdmin">
                                    <el-radio :label="0">$96</el-radio>
                                    <el-image v-if="isAdmin&&form.sub54!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">$0</el-radio><br>
                                    <el-radio :label="2">$50</el-radio><br>
                                    <el-radio :label="3">$86</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub55!=2" :src="wrong"></el-image>
                                56) Based on the image below, what is the patient's Family Deductible?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub58"></el-image>
                            <el-form-item prop="sub55">
                                <el-radio-group ref="sub55" v-model="form.sub55" :disabled="isAdmin">
                                    <el-radio :label="0">$100</el-radio><br>
                                    <el-radio :label="1">$50</el-radio><br>
                                    <el-radio :label="2">$150</el-radio>
                                    <el-image v-if="isAdmin&&form.sub55!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">$1000</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub56!=0" :src="wrong"></el-image>
                                57) Based on the image below, does this plan downgrade composites on molars?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub59"></el-image>
                            <el-form-item prop="sub56">
                                <el-radio-group ref="sub56" v-model="form.sub56" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub56!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No</el-radio><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub57!=0" :src="wrong"></el-image>
                                58) Based on the image below, does this plan downgrade D2740 for molar teeth?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub60"></el-image>
                            <el-form-item prop="sub57">
                                <el-radio-group ref="sub57" v-model="form.sub57" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub57!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No</el-radio><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub58!=1" :src="wrong"></el-image>
                                59) Based on the image below, does this plan downgrade D2740 on premolars?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub61"></el-image>
                            <el-form-item prop="sub58">
                                <el-radio-group ref="sub58" v-model="form.sub58" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio><br>
                                    <el-radio :label="1">No</el-radio>
                                    <el-image v-if="isAdmin&&form.sub58!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub59!=0" :src="wrong"></el-image>
                                60) Based on the image below, are ALL prosthetics paid on the seat/delivery date?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub62"></el-image>
                            <el-form-item prop="sub59">
                                <el-radio-group ref="sub59" v-model="form.sub59" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio>
                                    <el-image v-if="isAdmin&&form.sub59!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">No</el-radio><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub60!=1" :src="wrong"></el-image>
                                61) Based on the image below, what is the COB (Coordination of benefits) for this plan?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub63"></el-image>
                            <el-form-item prop="sub60">
                                <el-radio-group ref="sub60" v-model="form.sub60" :disabled="isAdmin">
                                    <el-radio :label="0">Non-Duplication</el-radio><br>
                                    <el-radio :label="1">Standard</el-radio>
                                    <el-image v-if="isAdmin&&form.sub60!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Carve-out plan</el-radio><br>
                                    <el-radio :label="3">Maintenance of benefits</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub61!=1" :src="wrong"></el-image>
                                62) What is the most important piece of information needed from this section of the
                                verification form to secure before you hang up with a representative?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub64"></el-image>
                            <el-form-item prop="sub61">
                                <el-radio-group ref="sub61" v-model="form.sub61" :disabled="isAdmin">
                                    <el-radio :label="0">Payor ID</el-radio><br>
                                    <el-radio :label="1">Call reference number and Insurance rep name</el-radio>
                                    <el-image v-if="isAdmin&&form.sub61!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Insurance Company Address</el-radio><br>
                                    <el-radio :label="3">Group Name</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub62!=1" :src="wrong"></el-image>
                                63) Based on the image below, the member has all of their Calendar Year Maximum remaining.
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub65"></el-image>
                            <el-form-item prop="sub62">
                                <el-radio-group ref="sub62" v-model="form.sub62" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub62!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub63!=1" :src="wrong"></el-image>
                                64) Based on the image below, What is the Group Number?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub66"></el-image>
                            <el-form-item prop="sub63">
                                <el-radio-group ref="sub63" v-model="form.sub63" :disabled="isAdmin">
                                    <el-radio :label="0">U10371298</el-radio><br>
                                    <el-radio :label="1">3174776</el-radio>
                                    <el-image v-if="isAdmin&&form.sub63!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub64!=3" :src="wrong"></el-image>
                                65) Based on the image below. What is the Orthodontic Maximum?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub67"></el-image>
                            <el-form-item prop="sub64">
                                <el-radio-group ref="sub64" v-model="form.sub64" :disabled="isAdmin">
                                    <el-radio :label="0">$2,000 Calendar Year</el-radio><br>
                                    <el-radio :label="1">$2,500 Calendar Year</el-radio><br>
                                    <el-radio :label="2">$2,000 Lifetime</el-radio><br>
                                    <el-radio :label="3">$2,500 Lifetime</el-radio>
                                    <el-image v-if="isAdmin&&form.sub64!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub65!=3" :src="wrong"></el-image>
                                66) What does the following statement mean from the image below?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub68"></el-image>
                            <el-form-item prop="sub65">
                                <el-radio-group ref="sub65" v-model="form.sub65" :disabled="isAdmin">
                                    <el-radio :label="0">All fillings are covered at the same percentage amount.</el-radio><br>
                                    <el-radio :label="1">Certain fillings may be covered at a different rate.</el-radio><br>
                                    <el-radio :label="2">Fillings require a predetermination.</el-radio><br>
                                    <el-radio :label="3">Composite fillings will be downgraded to the amalgam rate.</el-radio>
                                    <el-image v-if="isAdmin&&form.sub65!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub66!=2" :src="wrong"></el-image>
                                67) Based on these images, is the verification form filled out correctly?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub69"></el-image>
                            <el-form-item prop="sub66">
                                <el-radio-group ref="sub66" v-model="form.sub66" :disabled="isAdmin">
                                    <el-radio :label="0">Yes- All are correct</el-radio><br>
                                    <el-radio :label="1">No- 1 place is wrong</el-radio><br>
                                    <el-radio :label="2">No- 2 places are wrong</el-radio>
                                    <el-image v-if="isAdmin&&form.sub66!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">No- 3 places are wrong</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub67!=0" :src="wrong"></el-image>
                                68) After reviewing the faxback and completed section of the verification form- what edits
                                are needed before considering this entry complete and accurate?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub70"></el-image>
                            <el-form-item prop="sub67">
                                <el-radio-group ref="sub67" v-model="form.sub67" :disabled="isAdmin">
                                    <el-radio :label="0">No corrections need to be made</el-radio>
                                    <el-image v-if="isAdmin&&form.sub67!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">Major percentage needs corrected to 90%</el-radio><br>
                                    <el-radio :label="2">The deductible is not waived on preventive services</el-radio><br>
                                    <el-radio :label="3">Composite frequency is 1/12mo</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub68!=1" :src="wrong"></el-image>
                                69) Patient S. Smith called and scheduled for an exam on 12/10/2019- Her last exam was
                                1/15/2019 and she had her six month exam on 6/12/19. Based on the image, will her insurance
                                benefits cover her appointment in December?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub71"></el-image>
                            <el-form-item prop="sub68">
                                <el-radio-group ref="sub68" v-model="form.sub68" :disabled="isAdmin">
                                    <el-radio :label="0">Yes</el-radio><br>
                                    <el-radio :label="1">No</el-radio>
                                    <el-image v-if="isAdmin&&form.sub68!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Maybe</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub69!=0" :src="wrong"></el-image>
                                70) Please review the completed verification form below: How many items are needed before
                                this Verification can be considered complete and accurate?
                                <span class="required">*</span></div>
                            <div class="score" >1 point</div>
                            <el-image class="mt10" :src="sub72"></el-image>
                            <el-form-item prop="sub69">
                                <el-radio-group ref="sub69" v-model="form.sub69" :disabled="isAdmin">
                                    <el-radio :label="0">5</el-radio>
                                    <el-image v-if="isAdmin&&form.sub69!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">6</el-radio><br>
                                    <el-radio :label="2">7</el-radio><br>
                                    <el-radio :label="3">8</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="btnLayout">
                            <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                            <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                        </div>
                    </el-form>
                </div>
                <div class="box" v-if="showResult&&hasFinished">
                    <h1 class="serviceTestTitle">Insurance Verication Test</h1>
                    <!--
                    <span>Of the parts of this exam that can be automatically graded you have recieved </span>
                     <span>{{correctNum}}</span>/{{totalNum}} ({{correctPercent}})-->
                     <span>Thank you for completing this knowledge assessment!</span><br/>
                     <span>Please allow up to three business days while we review your application.</span>
                     <br>
                    <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
                </div>
            </section>
        </div>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import xRay1 from "../../assets/pic/x-ray1.jpg"
    import xRay2 from "../../assets/pic/x-ray2.jpg"
    import xRay3 from "../../assets/pic/x-ray3.jpg"
    import xRay4 from "../../assets/pic/x-ray4.jpg"
    import sub46 from "../../assets/pic/ivTest_sub46.png"
    import sub47 from "../../assets/pic/ivTest_sub47.png"
    import sub48 from "../../assets/pic/ivTest_sub48.jpg"
    import sub49 from "../../assets/pic/ivTest_sub49.jpg"
    import sub50 from "../../assets/pic/ivTest_sub50.png"
    import sub51 from "../../assets/pic/ivTest_sub51.png"
    import sub52 from "../../assets/pic/ivTest_sub52.png"
    import sub53 from "../../assets/pic/ivTest_sub53.png"
    import sub54 from "../../assets/pic/ivTest_sub54.png"
    import sub55 from "../../assets/pic/ivTest_sub55.png"
    import sub56 from "../../assets/pic/ivTest_sub56.jpg"
    import sub57 from "../../assets/pic/ivTest_sub57.jpg"
    import sub58 from "../../assets/pic/ivTest_sub58.jpg"
    import sub59 from "../../assets/pic/ivTest_sub59.png"
    import sub60 from "../../assets/pic/ivTest_sub60.png"
    import sub61 from "../../assets/pic/ivTest_sub61.png"
    import sub62 from "../../assets/pic/ivTest_sub62.png"
    import sub63 from "../../assets/pic/ivTest_sub63.png"
    import sub64 from "../../assets/pic/ivTest_sub64.jpg"
    import sub65 from "../../assets/pic/ivTest_sub65.png"
    import sub66 from "../../assets/pic/ivTest_sub66.png"
    import sub67 from "../../assets/pic/ivTest_sub67.png"
    import sub68 from "../../assets/pic/ivTest_sub68.jpg"
    import sub69 from "../../assets/pic/ivTest_sub69.png"
    import sub70 from "../../assets/pic/ivTest_sub70.jpg"
    import sub71 from "../../assets/pic/ivTest_sub71.jpg"
    import sub72 from "../../assets/pic/ivTest_sub72.jpg"
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name: "Medical",
        components:{ApplyHeader,Side},
        data(){
            let validateEmptyFive = (rule, value, callback) => {
                console.log('here')
                if (!value.a&&!value.b&&!value.c&&!value.d&&!value.e) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            let validateEmptyFour = (rule, value, callback) => {
                console.log('here')
                if (!value.a&&!value.b&&!value.c&&!value.d) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            let validateEmptySeven = (rule, value, callback) => {
                console.log('here')
                if (!value.a&&!value.b&&!value.c&&!value.d&&!value.e&&!value.f&&!value.g) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            return{
                loading:false,
                rightAnswerSOAP:'Subjective, Objective, Assessment, Plan',
                wrong:wrong, right:right, xRay1:xRay1, xRay2:xRay2, xRay3:xRay3, xRay4:xRay4, sub46:sub46, sub47:sub47, sub48:sub48,
                sub49:sub49,sub50:sub50,sub51:sub51,sub52:sub52,sub53:sub53,sub54:sub54,sub55:sub55,sub56:sub56,sub57:sub57,sub58:sub58,
                sub59:sub59,sub60:sub60,sub61:sub61,sub62:sub62,sub63:sub63,sub64:sub64,sub65:sub65,sub66:sub66,sub67:sub67,sub68:sub68,
                sub69:sub69,sub70:sub70,sub71:sub71,sub72:sub72,
                exitVisible:false,
                confirmVisible:false,
                showResult:false,
                hasFinished:false,//代表页面初始化完毕,比如是显示做题结果结果还是显示题目
                smallScreen:false,
                correctNum:0,
                totalNum:70,//一共70道题目
                form:{
                    sub4:{},
                    sub35:{},
                    sub36:{},
                    sub43:{}
                },
                isAdmin:false,
                /**表单验证规则，所有选项都不允许为空  第10题和第26题如果一个都没有选也会提示**/
                rules: {
                    sub0: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub1: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub2: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub3: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub4: [
                        {required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFive,trigger: 'blur'}
                    ],
                    sub5: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub6: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub7: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub8: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub9: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub10: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub11: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub12: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub13: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub14: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub15: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub16: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub17: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub18: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub19: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub20: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub21: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub22: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub23: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub24: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub25: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub26: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub27: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub28: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub29: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub30: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub31: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub32: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub33: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub34: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub35: [
                        {required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFour, trigger: 'blur'},
                    ],
                    sub36: [
                        {required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptySeven,trigger: 'blur'}
                    ],
                    sub37: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub38: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub39: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub40: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub41: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub42: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub43: [
                        {required: true, message: 'Required', trigger: 'blur'},
                        {validator:validateEmptyFour, trigger: 'blur'},
                    ],
                    sub44: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub45: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub46: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub47: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub48: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub49: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub50: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub51: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub52: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub53: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub54: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub55: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub56: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub57: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub58: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub59: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub60: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub61: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub62: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub63: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub64: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub65: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub66: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub67: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub68: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub69: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                }
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                var per = (this.correctNum*100/this.totalNum).toFixed(2)+'%'
                return per
            },
            getHeight(){
                return document.documentElement.clientHeight
            }
        },
        methods:{
            getUserAnswerData(id,email){
                console.log('id',id);
                console.log('email',email);
                this.loading=true
                this.$axios.get(this.$URL.gradeUrl,{params:{serviceId:id,email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        console.log('用户答题数据',res)
                        /**取到用户答题数据重构form显示答题详情**/
                        if(res.data!=null){
                            var list = res.data.detail
                            this.deconstructData(list)
                            this.calScore()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            getData(){
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    var serviceId = this.$route.query.serviceId
                    var email = this.$route.query.email
                    var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.getUserAnswerData(serviceId,email)
                    this.isAdmin=true
                    return
                }
                var storeService = this.$store.state.serviceInfo
                //when no serviceid info, go back to service list
                console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return;
                }
                var user = localStorage.getItem('email')
                this.getUserAnswerData(storeService.serviceId,user)  
                if(storeService.overrideDate) {
                  return;
                }   
                var status = storeService.status
                if(status==2||status==3){
                    this.showResult=true
                    this.passPercent = (((storeService.servicePassScore||0)/this.totalNum).toFixed(2)*100)+'%'
                }
            },
            deconstructData(data){
                console.log('解构')
                if(!data)return
                // var jsonData = JSON.parse(data)
                var jsonData = data
                if(jsonData.length!=70){
                    console.log('答题数据错误')
                    return
                }
                for(var i=0;i<jsonData.length;i++){
                    var item=jsonData[i]
                    if(i==4||i==35||i==36||i==43){
                        if(item.indexOf('a')>=0)this.form['sub'+i].a=true
                        if(item.indexOf('b')>=0)this.form['sub'+i].b=true
                        if(item.indexOf('c')>=0)this.form['sub'+i].c=true
                        if(item.indexOf('d')>=0)this.form['sub'+i].d=true
                        if(item.indexOf('e')>=0)this.form['sub'+i].e=true
                        if(item.indexOf('f')>=0)this.form['sub'+i].f=true
                        if(item.indexOf('g')>=0)this.form['sub'+i].g=true
                    }else this.form['sub'+i]=item
                }
                this.form = JSON.parse(JSON.stringify(this.form))

            },
            rebuildData(){
                var list=[]
                for(var i=0;i<70;i++){
                    if(i==4||i==35||i==36||i==43){
                        var temList4=[],str4
                        if(this.form['sub'+i].a)temList4.push('a')
                        if(this.form['sub'+i].b)temList4.push('b')
                        if(this.form['sub'+i].c)temList4.push('c')
                        if(this.form['sub'+i].d)temList4.push('d')
                        if(this.form['sub'+i].e)temList4.push('e')
                        if(this.form['sub'+i].f)temList4.push('f')
                        if(this.form['sub'+i].g)temList4.push('g')
                        str4 = temList4.join('')
                        list.push(str4)
                    }else list.push(this.form['sub'+i])
                }
                return list
            },
            calScore(){//算正确分数 总分80
                var score=0
                this.correctNum=0
                if(this.form.sub0==0) {score+=1;this.correctNum++}
                if(this.form.sub1==0) {score += 1;this.correctNum++}
                if(this.form.sub2==1) {score += 1;this.correctNum++}
                if(this.form.sub3==4) {score += 1;this.correctNum++}
                if(this.form.sub4.a&&!this.form.sub4.b&&!this.form.sub4.c&&!this.form.sub4.d&&!this.form.sub4.e)
                    {score += 1;this.correctNum++}
                if(this.form.sub5==3) {score += 1;this.correctNum++}
                if(this.form.sub6==5) {score += 1;this.correctNum++}
                if(this.form.sub7==2) {score += 1;this.correctNum++}
                if(this.form.sub8==4) {score += 1;this.correctNum++}
                if(this.form.sub9==2) {score += 1;this.correctNum++}
                if(this.form.sub10==2) {score += 1;this.correctNum++}
                if(this.form.sub11==3) {score += 1;this.correctNum++}
                if(this.form.sub12==1) {score += 1;this.correctNum++}
                if(this.form.sub13==0) {score += 1;this.correctNum++}
                if(this.form.sub14==1) {score += 1;this.correctNum++}
                if(this.form.sub15==2) {score += 1;this.correctNum++}
                if(this.form.sub16==0) {score += 1;this.correctNum++}
                if(this.form.sub17==5) {score += 1;this.correctNum++}
                if(this.form.sub18==1) {score += 1;this.correctNum++}
                if(this.form.sub19==3) {score += 1;this.correctNum++}
                if(this.form.sub20==1) {score += 1;this.correctNum++}
                if(this.form.sub21==1) {score += 1;this.correctNum++}
                if(this.form.sub22==1) {score += 1;this.correctNum++}
                if(this.form.sub23==0) {score += 1;this.correctNum++}
                if(this.form.sub24==0) {score += 1;this.correctNum++}
                if(this.form.sub25==1) {score += 1;this.correctNum++}
                if(this.form.sub26==1) {score += 1;this.correctNum++}
                if(this.form.sub27==1) {score += 1;this.correctNum++}
                if(this.form.sub28==2) {score += 1;this.correctNum++}
                if(this.form.sub29==3) {score += 1;this.correctNum++}
                if(this.form.sub30==3) {score += 1;this.correctNum++}
                if(this.form.sub31==0) {score += 1;this.correctNum++}
                if(this.form.sub32==1) {score += 1;this.correctNum++}
                if(this.form.sub33==1) {score += 1;this.correctNum++}
                if(this.form.sub34==2) {score += 1;this.correctNum++}
                if(!this.form.sub35.a&&!this.form.sub35.b&&!this.form.sub35.c&&this.form.sub35.d)
                    {score += 1;this.correctNum++}
                if(!this.form.sub36.a&&this.form.sub36.b&&!this.form.sub36.c&&!this.form.sub36.d&&this.form.sub36.e&&this.form.sub36.f&&!this.form.sub36.g)
                    {score += 1;this.correctNum++}
                if(this.form.sub37==1) {score += 1;this.correctNum++}
                if(this.form.sub38==1) {score += 1;this.correctNum++}
                if(this.form.sub39==0) {score += 1;this.correctNum++}
                if(this.form.sub40==1) {score += 1;this.correctNum++}
                if(this.form.sub41==2) {score += 1;this.correctNum++}
                if(this.form.sub42==1) {score += 1;this.correctNum++}
                if(!this.form.sub43.a&&!this.form.sub43.b&&this.form.sub43.c&&!this.form.sub43.d)
                    {score += 1;this.correctNum++}
                if(this.form.sub44==1) {score += 1;this.correctNum++}
                if(this.form.sub45==0) {score += 1;this.correctNum++}
                if(this.form.sub46==1) {score += 1;this.correctNum++}
                if(this.form.sub47==0) {score += 1;this.correctNum++}
                if(this.form.sub48==1) {score += 1;this.correctNum++}
                if(this.form.sub49==0) {score += 1;this.correctNum++}
                if(this.form.sub50==1) {score += 1;this.correctNum++}
                if(this.form.sub51==0) {score += 1;this.correctNum++}
                if(this.form.sub52==1) {score += 1;this.correctNum++}
                if(this.form.sub53==1) {score += 1;this.correctNum++}
                if(this.form.sub54==0) {score += 1;this.correctNum++}
                if(this.form.sub55==2) {score += 1;this.correctNum++}
                if(this.form.sub56==0) {score += 1;this.correctNum++}
                if(this.form.sub57==0) {score += 1;this.correctNum++}
                if(this.form.sub58==1) {score += 1;this.correctNum++}
                if(this.form.sub59==0) {score += 1;this.correctNum++}
                if(this.form.sub60==1) {score += 1;this.correctNum++}
                if(this.form.sub61==1) {score += 1;this.correctNum++}
                if(this.form.sub62==1) {score += 1;this.correctNum++}
                if(this.form.sub63==1) {score += 1;this.correctNum++}
                if(this.form.sub64==3) {score += 1;this.correctNum++}
                if(this.form.sub65==3) {score += 1;this.correctNum++}
                if(this.form.sub66==2) {score += 1;this.correctNum++}
                if(this.form.sub67==0) {score += 1;this.correctNum++}
                if(this.form.sub68==1) {score += 1;this.correctNum++}
                if(this.form.sub69==0) {score += 1;this.correctNum++}
                return score
            },
            goPre(){
                this.$router.go(-1)
            },
            goBack(){
                this.$router.push({path:'/service'})
            },
            cancel(){
                this.exitVisible=true
            },
            submit(){
                var score=0,list=[]
                list = this.rebuildData()
                score = this.calScore()
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = 70
                params.positionId = 0
                params.status = score > storeService.servicePassScore ? 1: 0
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                this.loading=true
                this.$axios.post(this.$URL.serviceTestUrl,params).then(res=>{
                    this.loading=false
                    if(res.code==0){
                        this.goBack()
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            submitPrepare(){
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            console.log('submit',this.form)
                            this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
        },
        mounted() {
            var clientW = document.documentElement.clientWidth
            if(clientW<1220){
                this.smallScreen=true
            }
            this.getData()
        },
        watch:{
            '$route'(to,from){
                console.log(from.path)
                if(to.path==='/insuranceVerificationTest'){
                    this.getData()
                }
            }
        }
    }
</script>

<style scoped>
    .rightPic{
        width: 20px;
        position: absolute;
        right: 20px
    }
    .el-radio{
        width:200px;
        height:43px;
        line-height:20px!important;
    }
    .radioText{
        display: inline-block;
    }
    .box>>>.el-radio__label{
        vertical-align: middle!important;
    }
    .btnLayout{
        margin:10px 0 20px 15px
    }
    @media screen and (max-width: 1440px) {
        .btnLayout{
            margin:10px 0 20px 5px
        }
    }
    @media screen and (max-width: 1200px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
</style>
